import { getUTCHtmlId } from 'common/util/time';
import React, { useEffect } from 'react';
const ProgressBar = ({ percent, description }) => {
    let progressBarId = '';
    useEffect(() => {
        progressBarId = getUTCHtmlId();
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { htmlFor: progressBarId, className: "sr-only" }, description),
        React.createElement("progress", { className: "cm-progress-bar", id: progressBarId, value: percent, max: 100 }, percent + ' %')));
};
export function getProgressPercent(step, totalSteps, startProgressPercent = 0) {
    return (startProgressPercent + Math.round(step * ((100 - startProgressPercent) / totalSteps)));
}
export default ProgressBar;
